module.exports = __webpack_public_path__ + "static/media/GPRlogo.d42241d1.png";